<template>
  <v-container class="px-0 my-3">
    <v-row class="bg-white">
      <v-col cols="12" class="mt-5 d-flex justify-center">
        <v-icon icon="mdi-alert-circle-outline" class="text-color-0" size="70px"></v-icon>
      </v-col>
      <v-col cols="12" class="mt-2 text-color-0 text-center">
        <b>OOPS!</b><br>
        <span>Ocorreu um erro durante o carregamento da página.</span><br>
        <span>Por favor, aguarde alguns instantes e tente novamente.</span>
      </v-col>
      <v-col cols="12" class="mt-2 text-color-0 text-center">
        <v-btn variant="flat" size="x-large" class="bg-color-2 text-color-white mb-3" @click="Nav()">TENTAR NOVAMENTE</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'Erro',
  methods: {
    Nav(){
	    window.location = "/";
    }
  }
}
</script>